module.exports = __webpack_public_path__ + "img/lightning_img.e08e04fa.gif";